import { HiCheck, HiX } from "react-icons/hi";
import { useTranslation } from "@repo/core";
import { PASSWORD_RULES } from "../../utils/passwordRules";

interface PasswordChecklistProps {
  password: string;
}

/** Live "min 8 chars / uppercase / digit" checklist shown under the signup
 * password field, matching the design mockup. */
const PasswordChecklist = ({ password }: PasswordChecklistProps) => {
  const { t } = useTranslation();

  return (
    <ul className="mt-1.5 space-y-1">
      {PASSWORD_RULES.map((rule) => {
        const passed = rule.test(password);
        return (
          <li
            key={rule.key}
            className={`flex items-center gap-1.5 text-xs ${
              passed
                ? "text-green-600 dark:text-green-500"
                : "text-gray-500 dark:text-gray-400"
            }`}
          >
            {passed ? (
              <HiCheck size={14} className="shrink-0 text-green-500" />
            ) : (
              <HiX size={14} className="shrink-0 text-red-400" />
            )}
            <span>{t(`signup.passwordRules.${rule.key}`)}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default PasswordChecklist;
